import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import {
  ACCOUNT_TYPE_IRA_SIMPLE,
  APPLICATION_TYPE_IRA,
  ACCOUNT_TYPE_IRA_SEP,
} from '../../constants/accountTypes';
import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { applicationTypeSetupSuccess } from '../../store/actions/application/applicationActions';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplicationRetirementBusiness = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { BrokerName } = useSelector(selectSettings);

  const options = [
    {
      title: t('selectPath.options.retirement.businessOwner.simple.title'),
      list: [
        {
          text: t(
            'selectPath.options.retirement.businessOwner.simple.taxDefer',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.businessOwner.simple.contributions',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.businessOwner.simple.employer',
          ),
          fontWeight: 600,
        },
      ],
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_IRA,
            AccountType: ACCOUNT_TYPE_IRA_SIMPLE,
          }),
        );
        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.retirement.businessOwner.sep.title'),
      list: [
        {
          text: t(
            'selectPath.options.retirement.businessOwner.sep.selfEmployed',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.businessOwner.sep.contributions',
          ),
        },
      ],
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_IRA,
            AccountType: ACCOUNT_TYPE_IRA_SEP,
          }),
        );
        history.push(PAGES.CREATE_ACCOUNT);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CREATE_APPLICATION.RETIREMENT.MAIN}
    >
      <Helmet>
        <title>
          {t('selectPath.options.retirement.businessOwner.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>
        {t('selectPath.options.retirement.businessOwner.title')}
      </Heading>
      <SelectList options={options} />
    </BaseLayout>
  );
};

export default CreateApplicationRetirementBusiness;
